<template>
  <div class="beat-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>f_beat = |f1 - f2|$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Wave 1 -->
          <path :d="getPath(f1, 40)" fill="none" stroke="#ff4757" stroke-width="1" opacity="0.4" />
          <text x="20" y="45" fill="#ff4757" font-size="8">波 1 (f1={{ f1 }}Hz)</text>

          <!-- Wave 2 -->
          <path :d="getPath(f2, 100)" fill="none" stroke="#00d2ff" stroke-width="1" opacity="0.4" />
          <text x="20" y="105" fill="#00d2ff" font-size="8">波 2 (f2={{ f2 }}Hz)</text>

          <!-- Superposition (Beat Wave) -->
          <rect x="20" y="130" width="360" height="80" fill="rgba(255,255,255,0.02)" />
          <path :d="getBeatPath()" fill="none" stroke="#ffd700" stroke-width="2" />
          <text x="20" y="145" fill="#ffd700" font-size="10">叠加波 (产生“拍”)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>拍频 f_beat: {{ Math.abs(f1 - f2).toFixed(1) }} Hz</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>波 1 频率 f1</label>
             <el-slider v-model="f1" :min="10" :max="50" size="mini"></el-slider>
          </div>
          <div class="row items-center">
             <label>波 2 频率 f2</label>
             <el-slider v-model="f2" :min="10" :max="50" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当两个频率相近的同方向简谐波进行叠加时，合成波的振幅会随时间发生周期性的强弱变化，这种现象称为**拍**。合成波的包络线频率等于两波频率之差。在调音工作中，调音师正是利用拍现象来确保乐器频率的一致性（当拍音消失，说明频率相同）。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BeatPhenomenonViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      f1: 30,
      f2: 33,
      time: 0,
      timer: null
    }
  },
  methods: {
    getPath(f, yBase) {
      let d = `M 20 ${yBase} `;
      for (let x = 0; x <= 360; x += 2) {
        let y = yBase + 15 * Math.sin(x * f * 0.005 - this.time);
        d += `L ${20 + x} ${y} `;
      }
      return d;
    },
    getBeatPath() {
      let d = `M 20 180 `;
      for (let x = 0; x <= 360; x += 2) {
        // Superposition: A1 sin(w1t) + A2 sin(w2t)
        let s = 15 * Math.sin(x * this.f1 * 0.005 - this.time) + 15 * Math.sin(x * this.f2 * 0.005 - this.time);
        d += `L ${20 + x} ${180 + s} `;
      }
      return d;
    },
    update() {
      this.time += 0.1;
      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.beat-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
